import React from "react";
import PropTypes from "prop-types";
const defaultAvatarStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 40,
  fontFamily: "'Roboto',Helvetica,Arial,sans-serif",
  fontSize: "1.25rem",
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  color: "#fff",
  backgroundColor: "#bdbdbd"
};
const CustomerAvatar = ({
  children,
  id = "cutomer-avatar-default-id",
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    style: {
      ...defaultAvatarStyle,
      ...rest.style
    }
  }, children);
};
CustomerAvatar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string
};
export default CustomerAvatar;